/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiWebhookHeaderFromJSON, StreemApiWebhookHeaderToJSON, } from './';
export function StreemApiCreateWebhookRequestFromJSON(json) {
    return StreemApiCreateWebhookRequestFromJSONTyped(json, false);
}
export function StreemApiCreateWebhookRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'method': !exists(json, 'method') ? undefined : json['method'],
        'timeoutMs': !exists(json, 'timeout_ms') ? undefined : json['timeout_ms'],
        'maxAttempts': !exists(json, 'max_attempts') ? undefined : json['max_attempts'],
        'headers': !exists(json, 'headers') ? undefined : (json['headers'].map(StreemApiWebhookHeaderFromJSON)),
    };
}
export function StreemApiCreateWebhookRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_sid': value.companySid,
        'label': value.label,
        'url': value.url,
        'method': value.method,
        'timeout_ms': value.timeoutMs,
        'max_attempts': value.maxAttempts,
        'headers': value.headers === undefined ? undefined : (value.headers.map(StreemApiWebhookHeaderToJSON)),
    };
}
//# sourceMappingURL=StreemApiCreateWebhookRequest.js.map